const logger = require("_js/logger.js");
const ua = require("_js/useragent.js");

import NoSleep from "nosleep.js";
import {debounce} from "lodash";

const EXCLUDE_DEVICES = ["iPhone 5/5c/5s/SE and 6/6s (Zoomed)"];
const OVERLAY_HEIGHT = 1500;

const INDENT = {
	landscape: ua.isChrome ? 25 : 0,
	portrait: 0
};

const CROME_RESIZE_DELAY = 400;
const idleResiseEvent = debounce(() => dispatchResizeEvent(), CROME_RESIZE_DELAY);

// eslint-disable-next-line consistent-return
const getIOSVersion = () => {
	if ((/iP(hone|od|ad)/).test(navigator.platform)) {
		const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

		return parseInt(v[1], 10);
	}

	// Detect iPadOS
	if (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform)) {
		const iPadV = navigator.appVersion.match(/Version\/(\d+).(\d+)/);

		return parseInt(iPadV[1], 10);
	}
};

const deviceSpecsByOS = new Map([
	[
		0, // Default - pre iOS13 device specs
		[
			[1280, 1762, 1920, 1280, 320, 480, 2, "iPhone 4/4s"],
			[1280, 2114, 2272, 1280, 320, 568, 2, "iPhone 5/5c/5s/SE and 6/6s (Zoomed)"],
			[1500, 2510, 2668, 1500, 375, 667, 2, "iPhone 6/6s/7/8"],
			[1656, 2785, 2944, 1656, 414, 736, 3, "iPhone 6+/6s+/7+/8+"],
			[1500, 2509, 2668, 1500, 375, 667, 3, "iPhone 6+/6s+/7+/8+ (Zoomed)"],

			[3072, 3936, 4096, 2912, 768, 1024, 1, "iPad 2"],
			[3072, 3938, 4096, 2914, 768, 1024, 2, "iPad Air/Retina/Pro (9.7-inch)"],
			[3336, 4290, 4448, 3178, 834, 1112, 2, "iPad Pro (10.5-inch)"],
			[3336, 4602, 4776, 3162, 834, 1194, 2, "iPad Pro (11-inch)"],
			[4096, 5306, 5464, 3938, 1024, 1366, 2, "iPad Pro (12.9-inch)"],
			[4096, 5290, 5464, 3922, 1024, 1366, 2, "iPad Pro (12.9-inch) 3rd generation"],

			[1656, 3330, 3584, 1656, 414, 896, 2, "iPhone XR"],
			[1500, 2993, 3248, 1500, 375, 812, 3, "iPhone X/XS"],
			[1656, 3329, 3584, 1656, 414, 896, 3, "iPhone XS Max"]
		]
	],
	[
		13,
		[
			[1280, 1764, 1920, 1280, 320, 480, 2, "iPhone 4/4s (iOS 13)"],
			[1280, 2116, 2272, 1280, 320, 568, 2, "iPhone 5/5c/5s/SE and 6/6s (Zoomed)"],
			[1500, 2512, 2668, 1500, 375, 667, 2, "iPhone 6/6s/7/8 (iOS 13)"],
			[1656, 2788, 2944, 1656, 414, 736, 3, "iPhone 6+/6s+/7+/8+ (iOS 13)"],
			[1500, 2512, 2668, 1500, 375, 667, 3, "iPhone 6+/6s+/7+/8+ (Zoomed) (iOS 13)"],

			[3072, 3940, 4096, 3166, 768, 1024, 2, "iPad Air/Retina/Pro (9.7-inch) (iOS 13)"],
			[3336, 4276, 4448, 3164, 834, 1112, 2, "iPad Pro (10.5-inch) (iOS 13)"],
			[3336, 4604, 4776, 3164, 834, 1194, 2, "iPad Pro (11-inch) (iOS 13)"],
			[4096, 5308, 5464, 3940, 1024, 1366, 2, "iPad Pro (12.9-inch) (iOS 13)"],
			[4096, 5292, 5464, 3924, 1024, 1366, 2, "iPad Pro (12.9-inch) 3rd generation (iOS 13)"],

			[1656, 3332, 3584, 1656, 414, 896, 2, "iPhone XR (iOS 13)"],
			[1500, 2996, 3248, 1500, 375, 812, 3, "iPhone X/XS (iOS 13)"],
			[1656, 3332, 3584, 1656, 414, 896, 3, "iPhone XS Max (iOS 13)"]
		]
	],
	[
		14,
		[
			[1280, 1764, 1920, 1280, 320, 480, 2, "iPhone 4/4s (iOS 14)"],
			[1280, 2116, 2272, 1280, 320, 568, 2, "iPhone 5/5c/5s/SE and 6/6s (Zoomed)"],
			[1500, 2512, 2668, 1500, 375, 667, 2, "iPhone 6/6s/7/8/SE2 (iOS 14)"],
			[1656, 2788, 2944, 1656, 414, 736, 3, "iPhone 6+/6s+/7+/8+ (iOS 14)"],
			[1500, 2512, 2668, 1500, 375, 667, 3, "iPhone 6+/6s+/7+/8+ (Zoomed) (iOS 14)"],

			[3072, 3940, 4096, 3166, 768, 1024, 2, "iPad Air/Retina/Pro (9.7-inch) (iOS 14)"],
			[3336, 4276, 4448, 3164, 834, 1112, 2, "iPad Pro (10.5-inch) (iOS 14)"],
			[3336, 4604, 4448, 3048, 834, 1194, 2, "iPad Pro (11-inch) (iOS 14)"],
			[4096, 5264, 4320, 3175, 810, 1080, 2, "iPad 8th generation (iOS 14)"],
			[4096, 5308, 5464, 3940, 1024, 1366, 2, "iPad Pro (12.9-inch) (iOS 14)"],
			[4096, 5292, 5464, 3924, 1024, 1366, 2, "iPad Pro (12.9-inch) 3rd generation (iOS 14)"],

			[1656, 3316, 3584, 1656, 414, 896, 2, "iPhone XR (iOS 14)"],
			[1500, 2996, 3248, 1500, 375, 812, 3, "iPhone X/XS/11/11 Pro (iOS 14)"],
			[1656, 3332, 3584, 1656, 414, 896, 3, "iPhone XS Max/11 Pro Max (iOS 14)"],
			[1712, 3452, 3704, 1712, 428, 926, 3, "iPhone 12 Pro Max"],
			[1440, 2868, 3120, 1440, 360, 780, 3, "iPhone 12 mini"],
			[1560, 3124, 3376, 1560, 390, 844, 3, "iPhone 12"],
			[1560, 3124, 3376, 1560, 390, 844, 3, "iPhone 12 Pro"]
		]
	],
	[
		15,
		[
			[1280, 1764, 1920, 1280, 320, 480, 2, "iPhone 4/4s (iOS 14)"],
			[1280, 2116, 2272, 1280, 320, 568, 2, "iPhone 5/5c/5s/SE and 6/6s (Zoomed)"],
			[1500, 2512, 2668, 1500, 375, 667, 2, "iPhone 6/6s/7/8/SE2 (iOS 14)"],
			[1656, 2788, 2944, 1656, 414, 736, 3, "iPhone 6+/6s+/7+/8+ (iOS 14)"],
			[1500, 2512, 2668, 1500, 375, 667, 3, "iPhone 6+/6s+/7+/8+ (Zoomed) (iOS 14)"],

			[3072, 3940, 4096, 3066, 768, 1024, 2, "iPad Air/Retina/Pro (9.7-inch) (iOS 14)"],
			[3336, 4276, 4448, 3064, 834, 1112, 2, "iPad Pro (10.5-inch) (iOS 15)"],
			[3336, 4604, 4448, 2948, 834, 1194, 2, "iPad Pro (11-inch) (iOS 15)"],
			[4096, 5264, 4320, 3075, 810, 1080, 2, "iPad 8th generation (iOS 14)"],
			[4096, 5308, 5464, 3840, 1024, 1366, 2, "iPad Pro (12.9-inch) (iOS 15)"],
			[4096, 5292, 5464, 3824, 1024, 1366, 2, "iPad Pro (12.9-inch) 3rd generation (iOS 15)"],

			[1656, 3150, 3584, 1656, 414, 896, 2, "iPhone XR (iOS 14)"],
			[1500, 2846, 3248, 1500, 375, 812, 3, "iPhone X/XS/11/11 Pro (iOS 14)"],
			[1656, 3165, 3584, 1656, 414, 896, 3, "iPhone XS Max/11 Pro Max (iOS 14)"],
			[1712, 3279, 3704, 1712, 428, 926, 3, "iPhone 12 Pro Max"],
			[1440, 2724, 3120, 1440, 360, 780, 3, "iPhone 12 mini"],
			[1560, 2967, 3376, 1560, 390, 844, 3, "iPhone 12"],
			[1560, 2967, 3376, 1560, 390, 844, 3, "iPhone 12 Pro"],
			[1560, 2967, 3376, 1500, 393, 852, 3, "iPhone 14 Pro"]
		]
	]
]);

let updateTimeoutId = null;
let isDisableIOSFS = false;
let checkSizeTimeoutId = null;

const windowSizes = {
	width: 0,
	height: 0
};

function getOrientation() {
	let orientation;
	if (window.matchMedia("(orientation: portrait)").matches) {
		orientation = "portrait";
	} else if (window.matchMedia("(orientation: landscape)").matches) {
		orientation = "landscape";
	}

	return orientation;
}

function getDeviceSpec() {
	const iOSVersion = getIOSVersion();
	const latestDefinedSpecOS = Array.from(deviceSpecsByOS.keys()).reduce((acc, key) => Math.max(acc, key), 0);

	const defaultSpec = iOSVersion > latestDefinedSpecOS
		? deviceSpecsByOS.get(latestDefinedSpecOS)
		: deviceSpecsByOS.get(0);

	const specs = deviceSpecsByOS.has(iOSVersion)
		? deviceSpecsByOS.get(iOSVersion)
		: defaultSpec;

	let index = specs.length;

	while (index--) {
		const {width, height} = window.screen;
		if (((window.devicePixelRatio === specs[index][6]) && (width === specs[index][4]) && (height === specs[index][5]))
			|| ((width === specs[index][5]) && (height === specs[index][4]))) {
			return specs[index];
		}
	}

	logger.error("Invalid iphone detection!", window.screen.width, window.screen.height);

	return null;
}

function init(isUseNoSleep = false, _isDisableIOSFS = false) {
	if (ua.isDesktop) return;

	if (isUseNoSleep) {
		initNoSleepController();
	}

	if (ua.isAndroid) {
		const overlay = document.getElementById("gl-overlay");
		overlay.className = "fullscreen";

		return;
	}

	isDisableIOSFS = _isDisableIOSFS;

	if (isDisableIOSFS) {
		return;
	}

	const is_exclude_device = isExcludeDevice();

	if (is_exclude_device) {
		document.getElementById("gl-overlay").style.opacity = 0;
	}

	disableGesture(); // hack for disable pich-zoom

	updatePosition();
	fixGameContent();

	window.game_resize_event = true;

	subscribeToOrientationChange(() => {
		updatePosition();
	});

	checkResize();
	enableCheckFS();
}

function checkResize() {
	checkSizeTimeoutId = setInterval(() => {
		if (window.innerHeight !== windowSizes.height || window.innerWidth !== windowSizes.width) {
			onResize();
		}
	}, 100);
}

function isUnableCheckFS() {
	return ua.isDesktop || ua.isAndroid || isDisableIOSFS || isIframe();
}

function enableCheckFS() {
	if (isUnableCheckFS()) return;

	updatePosition();

	const is_exclude_device = isExcludeDevice();
	clearInterval(updateTimeoutId);

	updateTimeoutId = setInterval(() => {
		const is_minimized = isMinimized();

		toggleGlOverlay(!is_minimized && !is_exclude_device);

		const overlay = document.getElementById("gl-overlay");

		if (!is_minimized) {
			overlay.style.height = `${OVERLAY_HEIGHT}px`;
		}
	}, 500);
}

function disableCheckFS() {
	if (isUnableCheckFS()) return;

	clearInterval(updateTimeoutId);

	toggleGlOverlay(false);
}

function disableIOSFS() {
	window.game_resize_event = false;

	disableCheckFS();
	isDisableIOSFS = true;

	document.getElementById("game-content").style.height = `100%`;
	document.getElementById("gl-overlay").style.height = `100%`;

	clearInterval(checkSizeTimeoutId);
}

function initNoSleepController() {
	const no_sleep_controller = new NoSleep();

	document.addEventListener("touchstart", function enableNoSleep() {
		document.removeEventListener("touchstart", enableNoSleep, false);
		no_sleep_controller.enable();

		window.addEventListener("beforeunload", function onBeforeUnload() {
			window.removeEventListener("beforeunload", onBeforeUnload, false);
			disableSleepController(no_sleep_controller);
		}, false);

		if (no_sleep_controller.noSleepVideo) {
			no_sleep_controller.noSleepVideo.addEventListener("pause", function reinit() {
				no_sleep_controller.noSleepVideo.removeEventListener("pause", reinit, false);
				disableSleepController(no_sleep_controller);

				initNoSleepController();
			}, false);
		}
	}, false);
}

function disableSleepController(no_sleep_controller) {
	no_sleep_controller.disable();

	if (no_sleep_controller.noSleepVideo) {
		no_sleep_controller.noSleepVideo.loop = false;
		no_sleep_controller.noSleepVideo.pause();
		no_sleep_controller.noSleepVideo.removeAttribute("src"); // empty source
		no_sleep_controller.noSleepVideo.load();
		no_sleep_controller.noSleepVideo = null;
	}

	no_sleep_controller = null;
}

function isExcludeDevice() {
	if (ua.isTelegramWebView) return true;
	if (ua.isFirefox) return true;

	const device_spec = getDeviceSpec();

	if (device_spec === null) return true;

	const device = device_spec[7];

	for (let i = 0; i < EXCLUDE_DEVICES.length; i++) {
		if (EXCLUDE_DEVICES[i] === device) return true;
	}

	return false;
}

function updatePosition() {
	window.scrollTo(0, 1);
}

function fixGameContent() {
	document.getElementById("game-content").style.position = "fixed";
}

function toggleGlOverlay(is_enabled) {
	const overlay = document.getElementById("gl-overlay");
	const hand = document.getElementsByClassName("hand")[0];
	overlay.className = "not-fullscreen hint";
	overlay.style.zIndex = is_enabled ? 10001 : -2;
	hand.style.zIndex = is_enabled ? 10002 : -1;

	if (Number(getIOSVersion()) === 15) {
		toggleForIOS15(is_enabled);
	}
}

function toggleForIOS15(is_need_minimize) {
	const is_need_disable_fs_trick = is_need_minimize || getOrientation() !== "portrait";

	const overlay = document.getElementById("gl-overlay");
	overlay.style.display = is_need_disable_fs_trick ? "block" : "none";
	overlay.style.height = is_need_disable_fs_trick ? `${OVERLAY_HEIGHT}px` : `100vh`;
	document.body.style.height = is_need_disable_fs_trick ? `` : `100vh`;
}

function subscribeToOrientationChange(cb) {
	window.addEventListener("orientationchange", cb);
}

function isMinimized() {
	const indent = getOrientation() === "landscape"
		? INDENT.landscape
		: INDENT.portrait;

	return window.innerHeight >= getMinimalViewHeight() - indent;
}

function onResize() {
	windowSizes.width = window.innerWidth;
	windowSizes.height = window.innerHeight;

	document.getElementById("game-content").style.height = `${window.innerHeight}px`;

	dispatchResizeEvent();
	idleResiseEvent();
}

function dispatchResizeEvent() {
	window.dispatchEvent(new Event("game_resize"));
}

function isIframe() {
	return window.self !== window.top;
}

function disableGesture() {
	document.addEventListener("gesturestart", (event) => {
		event.preventDefault();
	});
}

function getMinimalViewHeight() {
	let height = 0;

	const device_spec = getDeviceSpec();

	if (device_spec === null) return height;

	const viewport = {
		width: window.screen.width,
		height: window.screen.height
	};

	if (getOrientation() === "portrait") {
		height = Math.round(viewport.width * device_spec[1] / device_spec[0]) - 10;
	} else {
		height = Math.round(viewport.height * device_spec[3] / device_spec[2]);
	}

	return height;
}

module.exports = {init, getOrientation, enableCheckFS, disableCheckFS, disableIOSFS};



// WEBPACK FOOTER //
// ./js/device.js